import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const ImageIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 16" title={t`Image`} {...props}>
    <Path
      fill="currentColor"
      d="M12.667 1.25c1.15 0 2.083.933 2.083 2.083v9.334c0 1.15-.933 2.083-2.083 2.083H3.333a2.083 2.083 0 0 1-2.083-2.083V3.333c0-1.15.933-2.083 2.083-2.083h9.334ZM2.75 12.31v.357c0 .322.261.583.583.583h6.857L6 9.06l-3.25 3.25Zm.583-9.56a.583.583 0 0 0-.583.583v6.857l2.72-2.72.056-.052a.75.75 0 0 1 1.004.052l5.78 5.78h.357a.583.583 0 0 0 .583-.583V3.333a.583.583 0 0 0-.583-.583H3.333Zm6.667 1a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5Zm0 1.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z"
    />
  </Icon>
);
